<script setup lang="ts">
import { WidgetBreadcrumbs } from '~/components/widget/breadcrumbs'
import { WidgetFaqPageContent } from '~/components/widget/faq-page'

const { t } = useI18n()
const breadcrumbs = computed(() => [{ title: t('common.faq'), url: '/faq' }])
</script>

<template>
  <Main>
    <Container>
      <WidgetBreadcrumbs :links="breadcrumbs" />
      <div class="mt-8 grid grid-cols-1 gap-5 xl:grid-cols-4">
        <div class="space-y-8 xl:col-span-4">
          <WidgetFaqPageContent />
        </div>
      </div>
    </Container>
  </Main>
</template>
